import React from "react";
import { useHistory } from "react-router-dom";

import { ButtonLink } from "./styles";

export function FooterLink({
  disabled = null,
  rota = { pathname: "#" },
  children = null,
}) {
  const history = useHistory();
  function handleClick(rota) {
    history.push(rota);
  }

  return (
    <ButtonLink disabled={disabled} onClick={() => handleClick(rota)}>
      {children}
    </ButtonLink>
  );
}
